import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment fullDealProductConfig on ProductConfig {
    limits {
      inWindow {
        dateWindow {
          from
          to
        }
        eventWindow {
          daysAfter
          daysBefore
          type
        }
      }
      overTime {
        maxPrice {
          price {
            currency
            value
          }
          timePeriod
        }
        numberOfItems {
          number
          timePeriod
        }
      }
      perRedemption {
        maxPriceBeforeDiscounts
        minPriceBeforeDiscounts
        numberOfItems
        numberOfProducts
      }
      forOpenValue {
        minValue
        maxValue
        stepValue
      }
    }
    products {
      data {
        cinemaMetadata {
          enabled
          locations
        }
        externalMetadata {
          apiCode
          denomination
          nativeID
          openValue
          reservable
          advertiserId
        }
      }
      acqDiscount
      currency
      date
      dateUnix
      locale
      name
      supplier
      type
      uuid
      active
      provider
      vat
      externalIdentifier
      recomRetailPrice
      salePrice {
        originalCurrency
        currency
        discount
        value
        clippingPercentage
        originalCurrencyToRPExchangeRate
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
